import { render } from "./PlacesList.vue?vue&type=template&id=7eb08bfe&scoped=true"
import script from "./PlacesList.vue?vue&type=script&lang=js"
export * from "./PlacesList.vue?vue&type=script&lang=js"

import "./PlacesList.vue?vue&type=style&index=0&id=7eb08bfe&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb08bfe"]])

export default __exports__